import React, { useState, Component } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { NewsletterSection as MapSection } from '../components/MapSection';
import { ChevronRight, MapPin, Phone, Mail, User, MessageSquare } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    queryType: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`${formData.queryType} - Peterson House Contact Form`);
    const body = encodeURIComponent(`Name: ${formData.name}\n` + `Email: ${formData.email}\n` + `Phone: ${formData.phone}\n` + `Query Type: ${formData.queryType}\n\n` + `Message:\n${formData.message}`);
    window.location.href = `mailto:info@petersonhouse.com.au?subject=${subject}&body=${body}`;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-white" data-id="element-838">
      {/* Header */}
      <Header variant="light" data-id="element-839" />

      {/* Hero Section */}
      <section className="relative min-h-[80vh] overflow-hidden pt-32" data-id="element-840">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterson-House-Photoshoot-20-9-18-Hi-Res-38.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-841" />
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-842" />

        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-843">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-844" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-845">
            Get In Touch
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-846">
            Contact Us
          </h1>
          <p className="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto" data-id="element-847">
            We'd love to hear from you. Whether you have a question about our
            wines, events, or anything else, our team is ready to answer all
            your questions.
          </p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="bg-white py-20 px-8" data-id="element-848">
        <div className="max-w-6xl mx-auto" data-id="element-849">
          <div className="text-center mb-12" data-id="element-850">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-851" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-852">
              Visit Us
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-853">
              Peterson House Ltd
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-12 max-w-3xl mx-auto" data-id="element-854">
            {/* Address */}
            <div className="text-center" data-id="element-855">
              <div className="flex justify-center mb-4" data-id="element-856">
                <div className="w-12 h-12 bg-brand-pink/10 rounded-full flex items-center justify-center" data-id="element-857">
                  <MapPin className="w-6 h-6 text-brand-pink" data-id="element-858" />
                </div>
              </div>
              <h3 className="font-heading text-xl text-neutral-900 mb-3" data-id="element-859">
                Location
              </h3>
              <p className="text-neutral-600 leading-relaxed" data-id="element-860">
                2457 Broke Road
                <br data-id="element-861" />
                Pokolbin, NSW, 2320
              </p>
            </div>

            {/* Phone */}
            <div className="text-center" data-id="element-862">
              <div className="flex justify-center mb-4" data-id="element-863">
                <div className="w-12 h-12 bg-brand-pink/10 rounded-full flex items-center justify-center" data-id="element-864">
                  <Phone className="w-6 h-6 text-brand-pink" data-id="element-865" />
                </div>
              </div>
              <h3 className="font-heading text-xl text-neutral-900 mb-3" data-id="element-866">
                Phone
              </h3>
              <a href="tel:0249987881" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-867">
                02 4998 7881
              </a>
            </div>
          </div>

          {/* Special Note */}
          
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="bg-neutral-900 py-20 px-8" data-id="element-868">
        <div className="max-w-3xl mx-auto" data-id="element-869">
          <div className="text-center mb-12" data-id="element-870">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-871" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-872">
              Send Us A Message
            </div>
            <h2 className="font-heading text-5xl font-normal text-white mb-6" data-id="element-873">
              Get In Touch
            </h2>
            <p className="text-base text-neutral-300 leading-relaxed" data-id="element-874">
              Fill out the form below and our team will get back to you as soon
              as possible.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-875">
            <div className="grid md:grid-cols-2 gap-6" data-id="element-876">
              <div data-id="element-877">
                <label htmlFor="name" className="block text-sm text-neutral-300 mb-2" data-id="element-878">
                  Your Name *
                </label>
                <div className="relative" data-id="element-879">
                  <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-880" />
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} placeholder="Enter your name" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-881" />
                </div>
              </div>

              <div data-id="element-882">
                <label htmlFor="email" className="block text-sm text-neutral-300 mb-2" data-id="element-883">
                  Email Address *
                </label>
                <div className="relative" data-id="element-884">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-885" />
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} placeholder="your@email.com" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-886" />
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-887">
              <div data-id="element-888">
                <label htmlFor="phone" className="block text-sm text-neutral-300 mb-2" data-id="element-889">
                  Phone Number *
                </label>
                <div className="relative" data-id="element-890">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-891" />
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="0400 000 000" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-892" />
                </div>
              </div>

              <div data-id="element-893">
                <label htmlFor="queryType" className="block text-sm text-neutral-300 mb-2" data-id="element-894">
                  Query Type *
                </label>
                <div className="relative" data-id="element-895">
                  <MessageSquare className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-896" />
                  <select id="queryType" name="queryType" required value={formData.queryType} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors appearance-none cursor-pointer" data-id="element-897">
                    <option value="" data-id="element-898">Select query type</option>
                    <option value="General Enquiries" data-id="element-899">General Enquiries</option>
                    <option value="Wine Club" data-id="element-900">Wine Club</option>
                    <option value="Weddings & Events" data-id="element-901">Weddings & Events</option>
                    <option value="Cellar Door" data-id="element-902">Cellar Door</option>
                    <option value="Restaurant Enquiries" data-id="element-903">
                      Restaurant Enquiries
                    </option>
                    <option value="Production Enquiries" data-id="element-904">
                      Production Enquiries
                    </option>
                    <option value="Export & Wholesale Enquiries" data-id="element-905">
                      Export & Wholesale Enquiries
                    </option>
                    <option value="Marketing Enquiries" data-id="element-906">
                      Marketing Enquiries
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div data-id="element-907">
              <label htmlFor="message" className="block text-sm text-neutral-300 mb-2" data-id="element-908">
                Your Message *
              </label>
              <textarea id="message" name="message" rows={6} required value={formData.message} onChange={handleChange} placeholder="Tell us how we can help you..." className="w-full bg-neutral-800 border border-neutral-600 text-white px-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400 resize-none" data-id="element-909" />
            </div>

            <div className="text-center pt-4" data-id="element-910">
              <button type="submit" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-4 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-911">
                <Mail size={18} data-id="element-912" />
                Send Message
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-913" />
              </button>
            </div>

            
          </form>
        </div>
      </section>

      {/* Map Section */}
      <MapSection data-id="element-914" />

      {/* License Information Section */}
      <section className="bg-white py-12 px-8" data-id="element-915">
        <div className="max-w-4xl mx-auto text-center" data-id="element-916">
          <div className="grid md:grid-cols-3 gap-6 text-sm text-neutral-600" data-id="element-917">
            <div data-id="element-918">
              <p className="font-medium text-neutral-900 mb-1" data-id="element-919">
                Vigneron License
              </p>
              <p data-id="element-920">LIQW824002551</p>
            </div>
            <div data-id="element-921">
              <p className="font-medium text-neutral-900 mb-1" data-id="element-922">
                Liquor License
              </p>
              <p data-id="element-923">LIQO624013397</p>
            </div>
            <div data-id="element-924">
              <p className="font-medium text-neutral-900 mb-1" data-id="element-925">ABN</p>
              <p data-id="element-926">25 062 695 514</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-927" />
    </div>;
}